import {ENTWURFDATA, IEntwurfStoreWrapper} from "@k/js/EntwurfStateWrapper";
import {
    ChromoLogo,

    Logo,
    SelectableObject,
    StockLogo,
    TextObject
} from "@k/js/selectableObjects";
import {PatternInEntwurf} from "@k/js/pattern/patternEntwurfsobjektInteractor";
import {Color} from "@k/js/colorObject";
import {EntwurfConstructorArguments} from "@k/js/entwurfsObjekt";
import {EinzelExemplar} from "@k/global/einzelexemplare/einzelExemplarObject";
import {Z_OrderTable} from "@k/js/zOrderTable";
import {Store} from "vuex";
import {ColorCodeFarbKombiBeziehung} from "@k/js/databaseInterfaceClasses";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {PATTERN_EVENTNAMES} from "@k/js/pattern/patternFactory";


export class EntwurfStoreWrapperStore implements IEntwurfStoreWrapper {
    private store: Store<unknown>;

    public constructor(store) {
        this.store = store;
    }

    loadStatus = {
        exemplareList: false,
        logoObjects: false,
        textObjects: false
    }


    addLogo(logo: Logo | StockLogo | ChromoLogo): void {
        this.store.commit("ADD_LOGO", logo)
    }
    addPattern(patternInEntwurf: PatternInEntwurf): void {
        this.store.commit("ADD_PATTERN", patternInEntwurf)
    }
    addTextObject(clone: TextObject): void {
        this.store.commit("ADD_TEXTOBJECT", clone);
    }
    commentCloneDeleted(origId: string, cloneID: string): void {
        this.store.commit("COMMENTCLONE_DELETED", {origId, cloneID})
    }
    deletePatternForColorCode(colorCode: string, ignoreInHistory = false): void {
        this.store.commit("DELETE_PATTERN_FOR_COLORCODE", colorCode);
    }

    deleteAllPatterns(ignoreInHistory: boolean): any {
        const colorCodes = this.store.getters.getEntwurfData.patterns.map(p=>p.forColorCode).filter((value,index,array)=>array.indexOf(value) === index);
        colorCodes.forEach(c=>EventVerteiler.broadcast(PATTERN_EVENTNAMES.DELETED, {colorCodeNr: this.getColorCodeNr(c)}))
    }

    deleteSelObById(cloneId): void {
        this.store.commit("DELETE_SELOB_BY_ID", cloneId)
    }
    emptyCommentIds(): void {
        this.store.commit("EMPTY_COMMENT_IDS");
    }
    getChangedSinceSave(): boolean {
        return this.store.getters.getChangedSinceSave
    }
    getColorCodeFromColorCodeNr(nr): string {
        return this.store.getters.getColorCodeFromColorCodeNr(nr);
    }
    getColorCodeNr(colorcodeString): number {
        return this.store.getters.getColorCodeNr(colorcodeString);
    }
    getColorObjectByColorCode(changedColorCode): Color {
        return this.store.getters.getColorObjectByColorCode(changedColorCode);
    }
    getColorObjects(): Color[] {
        return this.store.getters.getColorObjects;
    }
    getCommentIdsWithoutClones(): string[] {
        return this.store.getters.getCommentIdsWithoutClones;
    }

    getDesign(): string {
        return this.store.getters.getCurrentDesignname;
    }
    getExemplarListe(): EinzelExemplar[] {
        return this.store.getters.getExemplarListe
    }
    getFBPostID(): string {
        return this.store.getters.getFBPostID;
    }
    getRdyDesignID(): string {
        return this.store.getters.getRdyDesignID;
    }
    getHerstellerlogosDeleted(): boolean {
        return this.store.getters.getHerstellerlogosEntfernt;
    }
    getFarbvariante(): string {
        return this.store.getters.getFarbvariante;
    }
    getID(): string {
        return this.store.getters.getEntwurfsID;
    }
    getInBasket(): boolean {
        return this.store.getters.getInBasket;
    }
    getLogoObjects(): Array<Logo | StockLogo | ChromoLogo> {
        return this.store.getters.getLogoObjects;
    }
    getModel(): string {
        return this.store.getters.getModel;
    }
    getName(): string {
        return this.store.getters.getEntwurfname;
    }
    getOwayoLogosOnTop(): boolean {
        return this.store.getters.getOwayoLogosOnTop
    }
    getPattern(colorCode: string): PatternInEntwurf {
        return this.store.getters.getPattern(colorCode);
    }
    getPatterns(): PatternInEntwurf[] {
        return this.store.getters.getPatterns;
    }
    getProductCategory(): string {
        return this.store.getters.getProductCategory
    }
    getSelOb(id): SelectableObject {
        return this.store.getters.getSelOb(id);
    }
    getSelectableObject(id: string): SelectableObject {
        return this.store.getters.getSelOb(id);
    }
    getTextObjects(): TextObject[] {
        return this.store.getters.getTextObjects;
    }
    getZOrderTable(): Z_OrderTable {
        return this.store.getters.getZOrderTable;
    }
    insertZIndexEntry(id: string, cloneIds: string[], floating: number): void {
        this.store.commit("INSERT_ZINDEX_ENTRY", {id, cloneIds, floating})
    }
    isOwayoLogosOnTop(): boolean {
        return this.store.getters.isOwayoLogosOnTop;
    }
    loadColorValues(colors): void {
        this.store.commit("LOAD_COLOR_VALUES", colors)
    }
    loadComments(comments): void {
        this.store.commit("LOAD_COMMENTS", comments || []);
    }
    loadEinzelexemplare(einzelexemplare): void {
        this.store.commit("LOAD_EINZELEXEMPLARE", einzelexemplare)
    }
    loadLogoObjects(logos): void {
        this.store.commit("LOAD_LOGOOBJECTS", logos);
    }

    loadTextObjects(textobjects): void {
        this.store.commit("LOAD_TEXTOBJECTS", textobjects);
    }

    needsSaving(): boolean {
        return this.store.getters.needsSaving;
    }
    setChangedSinceSave(b: boolean): void {
        this.store.commit("SET_CHANGED_SINCE_SAVE_FLAG", b);
    }
    setCloneFlags(): void {
        this.store.commit("SET_CLONE_FLAGS");
    }
    setColorObjects(aliases: Color[]): void {
        this.store.commit("SET_COLOROBJECTS", aliases);
    }
    setDependencyAndDependentColorValues(farbBeziehungenZwischenColorCodes:ColorCodeFarbKombiBeziehung[]): void {
        this.store.commit("SET_DEPENDENCY_AND_DEPENDENT_COLOR_VALUES", farbBeziehungenZwischenColorCodes);
    }
    setDesignanfrage(b: boolean): void {
        this.store.commit("SET_DESIGNANFRAGE_FLAG", b);
    }
    setDesignname(name: string): void {
        this.store.commit("SET_ENTWURF_DESIGNNAME", name);
    }
    setEntwurfData(args:EntwurfConstructorArguments): void {
        this.store.commit("RESET_ENTWURF", args);
    }
    setExemplarListe(exemplare: EinzelExemplar[]): void {
        this.store.commit("SET_EXEMPLARLISTE", exemplare);
    }
    setFBPostID(response): void {
        this.store.commit("SET_FBPOST_ID", response);
    }
    setRdyDesignID(rdyDesignID): void {
        this.store.commit("SET_RDYDESIGN_ID", rdyDesignID);
    }
    setHerstellerlogosDeleted(deleted:boolean): void {
        this.store.commit("SET_HERSTELLERLOGO_AS_DELETED", deleted);
    }
    setFarbvariante(variantenName: string): void {
        this.store.commit("SET_FARBVARIANTE", variantenName);
    }
    setID(s: string): void {
        this.store.commit("SET_ENTWURF_ID", s);
    }
    setInBasket(b: boolean): void {
        this.store.commit("SET_INBASKET_FLAG", b);
    }
    setName(name): void {
        this.store.commit("SET_ENTWURF_NAME", name);
    }
    setOwayoLogosOnTop(b: boolean): void {
        this.store.commit("SET_OWAYO_LOGOS_ON_TOP_FLAG", b);
    }
    updateColorCodes(colorCodes, ColorCodeFarbVorbelegungen, ColorCodeAbhaengigkeiten, farbBeziehungenZwischenColorCodes:ColorCodeFarbKombiBeziehung[]): void {
        this.store.commit("UPDATE_COLORCODES", {colorCodes, ColorCodeFarbVorbelegungen, ColorCodeAbhaengigkeiten, farbBeziehungenZwischenColorCodes});
    }
    wasOrdered(): boolean {
        return false;
    }
    getZIndex(id: string): number {
        return this.store.getters.getZIndex(id);
    }

    addColor(c: Color) {
        this.store.commit("ADD_COLOR", c)
    }

    addExemplar(newEinzelexemplar: EinzelExemplar) {
        this.store.commit("ADD_EXEMPLAR", newEinzelexemplar);
    }

    getBasedOnDeprecatedProduct() {
        return this.store.getters.getbasedOnDeprecatedProduct;
    }

    getDesignanfrage() {
        return this.store.getters.getDesignAnfrage;
    }

    getUploadedByOwayo() {
        return this.store.getters.getUploadedByOwayo;
    }

    replaceColorObject(index, newColor) {
        this.store.commit("REPLACE_COLOROBJECT", {index, newColor})
    }

    setBasedOnDeprecatedProduct(b: boolean) {
        this.store.commit("SET_BASED_ON_DEPRECATED_PRODUCT", b);
    }

    setCommentIdsWithoutClones(s: string[]) {
        this.store.commit("SET_COMMENT_IDSWITHOUTCLONES", s);
    }



    setLogoObjects(l: (Logo | StockLogo | ChromoLogo)[]) {
        this.store.commit("SET_LOGOS", l);
    }

    setModel(m: string) {
        this.store.commit("SET_MODEL", m);
    }

    setPatterns(p: PatternInEntwurf[]) {
        this.store.commit("SET_PATTERNS", p);
    }

    setProductCategory(cat: string) {
        this.store.commit("SET_ENTWURF_PRODUCTCATEGORY", cat);
    }

    setTextObjects(t: TextObject[]) {
        this.store.commit("SET_TEXTS", t);
    }

    setUploadedByOwayo(b: boolean) {
        this.store.commit("SET_UPLOADED_BY_OWAYO", b)
    }

    setWasOrdered(b: boolean) {
        this.store.commit("SET_ENTWURF_WAS_ORDERED", b);
    }

    setZOrderTable(z: Z_OrderTable) {
        this.store.commit("SET_ZORDER_TABLE", z);
    }

    resetLoadStatus() {
        this.store.commit("RESET_LOADSTATUS");
    }
    SET_ENTWURF_changedSinceSave(){
        this.store.commit("SET_ENTWURF_changedSinceSave")
    }

    setLoadStatusToTrue(whichone: "TEXT" | "LOGO" | "COLOR" | "COMMENT" | "EXEMPLARLISTE") {
        this.store.commit("SET_LOADSTATUSTOTRUE", whichone);
    }

    getEntwurfData(): ENTWURFDATA {
        return this.store.getters.getEntwurfData
    }
}
